// // src/contexts/RevenueCatContext.jsx
// // 
// // OPTIMIZED VERSION: Lazy loads the RevenueCat SDK only when a user is logged in.
// // This saves ~150 KiB from the initial bundle.

// import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
// import { REVENUECAT_CONFIG } from '../config/revenueCatConfig';
// // import { Purchases } from '@revenuecat/purchases-js';
// const RevenueCatContext = createContext(null);

// export const useRevenueCat = () => {
//   const context = useContext(RevenueCatContext);
//   if (!context) {
//     // Return safe defaults if used outside provider
//     return {
//       isReady: false,
//       loading: true,
//       isPro: false,
//       purchase: async () => ({ success: false, error: 'RevenueCat not initialized' }),
//       restore: async () => ({ success: false, error: 'RevenueCat not initialized' }),
//     };
//   }
//   return context;
// };

// export const RevenueCatProvider = ({ children, user }) => {
//   // Lazy-loaded Purchases module
//   const [PurchasesModule, setPurchasesModule] = useState(null);
//   const [purchasesInstance, setPurchasesInstance] = useState(null);
//   const [customerInfo, setCustomerInfo] = useState(null);
//   const [offerings, setOfferings] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Check if user has Pro entitlement
//   const isPro = customerInfo?.entitlements?.active?.[REVENUECAT_CONFIG.entitlements.pro] !== undefined;

//   // Get subscription info
//   const subscriptionInfo = customerInfo?.entitlements?.active?.[REVENUECAT_CONFIG.entitlements.pro];

//   // Lazy load the RevenueCat SDK only when user logs in
//   useEffect(() => {
//     const loadSDK = async () => {
//       if (!user?.uid) {
//         // No user - don't load SDK
//         setPurchasesModule(null);
//         setPurchasesInstance(null);
//         setCustomerInfo(null);
//         setOfferings(null);
//         setLoading(false);
//         return;
//       }

//       // Only load if not already loaded
//       if (!PurchasesModule) {
//         try {
//           if (REVENUECAT_CONFIG.debug) {
//             console.log('🛒 Lazy loading RevenueCat SDK...');
//           }
          
//           // Dynamic import - this creates a separate chunk
//           setPurchasesModule(Purchases);
          
//           if (REVENUECAT_CONFIG.debug) {
//             console.log('🛒 RevenueCat SDK loaded');
//           }
//         } catch (err) {
//           console.error('Failed to load RevenueCat SDK:', err);
//           setError(err);
//           setLoading(false);
//         }
//       }
//     };

//     loadSDK();
//   }, [user?.uid, PurchasesModule]);

//   // Initialize RevenueCat when SDK is loaded and user is present
//   useEffect(() => {
//     const initAndSync = async () => {
//       if (!PurchasesModule || !user?.uid) {
//         return;
//       }

//       setLoading(true);
//       setError(null);

//       try {
//         if (REVENUECAT_CONFIG.debug) {
//           console.log('🛒 Configuring RevenueCat for user:', user.uid);
//         }

//         // FIXED: Configure with object syntax for Web SDK
//         const instance = PurchasesModule.configure({
//           apiKey: REVENUECAT_CONFIG.apiKey,
//           appUserId: user.uid,
//         });
//         setPurchasesInstance(instance);

//         if (REVENUECAT_CONFIG.debug) {
//           console.log('🛒 RevenueCat configured, instance:', instance);
//         }

//         // Web SDK: methods are on the instance, not static
//         if (instance) {
//           // Get customer info
//           const info = await instance.getCustomerInfo();
//           setCustomerInfo(info);

//           if (REVENUECAT_CONFIG.debug) {
//             console.log('🛒 Customer info:', info);
//             console.log('🛒 Active entitlements:', info?.entitlements?.active);
//           }

//           // Fetch offerings
//           const offeringsResult = await instance.getOfferings();
//           setOfferings(offeringsResult);

//           if (REVENUECAT_CONFIG.debug) {
//             console.log('🛒 Offerings:', offeringsResult);
//           }
//         }
//       } catch (err) {
//         console.error('RevenueCat sync error:', err);
//         setError(err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     initAndSync();
//   }, [PurchasesModule, user?.uid]);

//   // Purchase a package
//   const purchase = useCallback(async (packageIdentifier = REVENUECAT_CONFIG.packages.monthly) => {
//     if (!purchasesInstance) {
//       console.error('RevenueCat not initialized');
//       return { success: false, error: 'RevenueCat not initialized' };
//     }

//     if (!offerings?.current) {
//       console.error('No offerings available');
//       return { success: false, error: 'No offerings available' };
//     }

//     const packageToBuy = offerings.current.availablePackages.find(
//       (p) => p.identifier === packageIdentifier
//     );

//     if (!packageToBuy) {
//       console.error(`Package ${packageIdentifier} not found`);
//       const anyPackage = offerings.current.availablePackages[0];
//       if (!anyPackage) {
//         return { success: false, error: 'No packages available' };
//       }
//       console.log('Using first available package:', anyPackage.identifier);
//     }

//     const finalPackage = packageToBuy || offerings.current.availablePackages[0];

//     try {
//       if (REVENUECAT_CONFIG.debug) {
//         console.log('🛒 Purchasing package:', finalPackage);
//       }

//       const result = await purchasesInstance.purchase({ rcPackage: finalPackage });
//       setCustomerInfo(result.customerInfo);

//       if (REVENUECAT_CONFIG.debug) {
//         console.log('🛒 Purchase successful:', result);
//       }

//       return { success: true, customerInfo: result.customerInfo };
//     } catch (err) {
//       if (err.userCancelled) {
//         if (REVENUECAT_CONFIG.debug) {
//           console.log('🛒 User cancelled purchase');
//         }
//         return { success: false, cancelled: true };
//       }
//       console.error('Purchase error:', err);
//       return { success: false, error: err };
//     }
//   }, [purchasesInstance, offerings]);

//   // Restore/refresh purchases
//   const restore = useCallback(async () => {
//     if (!purchasesInstance) {
//       return { success: false, error: 'RevenueCat not initialized' };
//     }

//     try {
//       if (REVENUECAT_CONFIG.debug) {
//         console.log('🛒 Restoring purchases...');
//       }

//       const info = await purchasesInstance.getCustomerInfo();
//       setCustomerInfo(info);

//       if (REVENUECAT_CONFIG.debug) {
//         console.log('🛒 Restore complete:', info);
//       }

//       return { success: true, customerInfo: info };
//     } catch (err) {
//       console.error('Restore error:', err);
//       return { success: false, error: err };
//     }
//   }, [purchasesInstance]);

//   // Refresh customer info
//   const refresh = useCallback(async () => {
//     if (!purchasesInstance) return null;

//     try {
//       const info = await purchasesInstance.getCustomerInfo();
//       setCustomerInfo(info);
//       return info;
//     } catch (err) {
//       console.error('Refresh error:', err);
//       return null;
//     }
//   }, [purchasesInstance]);

//   // Get the current offering's monthly package
//   const monthlyPackage = offerings?.current?.availablePackages?.find(
//     (p) => p.identifier === REVENUECAT_CONFIG.packages.monthly
//   ) || offerings?.current?.availablePackages?.[0];

//   // Get price string
//   const monthlyPrice = monthlyPackage?.product?.priceString || '$8.00';

//   const value = {
//     // State
//     isReady: !!purchasesInstance,
//     loading,
//     error,
//     customerInfo,
//     offerings,

//     // Computed
//     isPro,
//     subscriptionInfo,
//     monthlyPackage,
//     monthlyPrice,

//     // All available packages
//     availablePackages: offerings?.current?.availablePackages || [],

//     // Actions
//     purchase,
//     restore,
//     refresh,
//   };

//   return (
//     <RevenueCatContext.Provider value={value}>
//       {children}
//     </RevenueCatContext.Provider>
//   );
// };

// export default RevenueCatProvider;

// src/contexts/RevenueCatContext.jsx
// DISABLED - RevenueCat temporarily removed for performance
// To re-enable: restore the full implementation and uncomment in App.js

import React, { createContext, useContext } from 'react';

const RevenueCatContext = createContext(null);

export const useRevenueCat = () => ({
  isReady: false,
  loading: false,
  isPro: false,
  error: null,
  customerInfo: null,
  offerings: null,
  subscriptionInfo: null,
  monthlyPackage: null,
  monthlyPrice: '$8.00',
  availablePackages: [],
  purchase: async () => ({ success: false, error: 'Billing disabled' }),
  restore: async () => ({ success: false, error: 'Billing disabled' }),
  refresh: async () => null,
});

export const RevenueCatProvider = ({ children }) => (
  <RevenueCatContext.Provider value={null}>
    {children}
  </RevenueCatContext.Provider>
);

export default RevenueCatProvider;